<template>
  <el-row>
    <el-col>
      <el-row :gutter="20">
        <el-col :lg="6">
          ID:  <el-input type="number" v-model="searchId" ></el-input>
        </el-col>
        <el-col :lg="6">
          Status:  <status-dropdown v-model="statusId" :inputModel="statusId"></status-dropdown>
        </el-col>
        <el-col :lg="6">
          Owner:  <user-dropdown v-model="owner" :inputModel="owner"></user-dropdown>
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20">
        <el-col :lg="6">
          Name:  <el-input v-model="peaName" type="textarea" :maxlength="100" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-col>
        <el-col :lg="6">
          Cost Center:  <el-input v-model="costCenter"  :maxlength="5"></el-input>
        </el-col>
        <el-col :lg="6">
          Capital Budget ID:  <el-input v-model="budget" :maxlength="50"></el-input>
        </el-col>
        <el-col :lg="6">
          Reason:  <reason-dropdown v-model="reason" :inputModel="reason"></reason-dropdown>
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20">
        <el-col :lg="6">
          Department:    <department-dropdown v-model="deptId" :inputModel="deptId"></department-dropdown>
        </el-col>
        <el-col :lg="6">
          Division:  <all-division-dropdown v-model="divisionId" :inputModel="divisionId"></all-division-dropdown>
        </el-col>
        <el-col :lg="12">
          Emergency:
          <el-select v-model="emergency">
            <el-option value="" label="All PEAs"></el-option>
            <el-option value="true" label="Only PEAS Marked Emergency"></el-option>
            <el-option value="false" label="Only PEAs NOT marked emergency"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20">
        <el-col :lg="12">
          Description:  <el-input v-model="desc" type="textarea" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-col>
        <el-col :lg="12">
          Search All Text:  <el-input v-model="allText" type="textarea" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-col>
      </el-row>
      <br>
      <br>
      <h3 :class="{closed: !panelStatusOpen}">Comments and Status Change<span class="toggle" @click="panelStatusOpen = panelStatusOpen !== true" :class="{closed: !panelStatusOpen}"></span></h3>
      <transition name="panel">
        <el-row :gutter="20" class="pea-panel" v-if="panelStatusOpen">
          <el-col :lg="24">
            <el-row :gutter="20">
              <el-col :lg="6">
                Commented On By:
              </el-col>
              <el-col :lg="6">
                <user-dropdown v-model="commentUserId" :inputModel="commentUserId"></user-dropdown>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Approved By:
              </el-col>
              <el-col :lg="6">
                <user-dropdown v-model="approveUserId" :inputModel="approveUserId"></user-dropdown>
              </el-col>
            </el-row>
            <br><br>
            <el-row :gutter="20">
              <el-col :lg="2">
                Status
              </el-col>
              <el-col :lg="5">
                <status-dropdown v-model="historyStatusId" :inputModel="historyStatusId"></status-dropdown>
              </el-col>
              <el-col :lg="5">
                Occured Between
              </el-col>
              <el-col :lg="12">
                <el-date-picker
                v-model="statusToFrom"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="min-width:400px;" />
              </el-col>
            </el-row>
            <br>
          </el-col>
        </el-row>
      </transition>
      <br>
      <br>
      <h3 :class="{closed: !panelCostOpen}">Costs<span class="toggle" @click="panelCostOpen = panelCostOpen !== true" :class="{closed: !panelCostOpen}"></span></h3>
      <transition name="panel">
        <el-row :gutter="20" class="pea-panel" v-if="panelCostOpen">
          <el-col :lg="24">
            <el-row :gutter="20">
              <el-col :lg="6">
                &nbsp;
              </el-col>
              <el-col :lg="6">
                From
              </el-col>
              <el-col :lg="6">
                To
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="6">
                Estimated Cost ($)
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="estCostFrom"></currency-input>
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="estCostTo"></currency-input>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Annual CRI Year 5 (%)
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="acri5From"></el-input>
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="acri5To"></el-input>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Annual CRI Year 10 (%)
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="acri10From"></el-input>
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="acri10To"></el-input>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Cummulative CRI Year 5 (%)
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="ccri5From"></el-input>
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="ccri5To"></el-input>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Cummulative CRI Year 10 (%)
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="ccri10From"></el-input>
              </el-col>
              <el-col :lg="6">
                <el-input type="number" v-model="ccri10To"></el-input>
              </el-col>
            </el-row>
            <br><br>
            <el-row :gutter="20">
              <el-col :lg="6">
                &nbsp;
              </el-col>
              <el-col :lg="6">
                &nbsp;
              </el-col>
              <el-col :lg="6">
                From
              </el-col>
              <el-col :lg="6">
                To
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="6">
                Cost In Asset Classification:
              </el-col>
              <el-col :lg="6">
                <asset-classification v-model="assetClassId"></asset-classification>
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="assetClassFrom"></currency-input>
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="assetClassTo"></currency-input>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Cost In Asset Category:
              </el-col>
              <el-col :lg="6">
                <el-select :clearable="true" v-model="assetCatId" placeholder="Select">
                  <el-option label="Capital Assets" :value="1">
                  </el-option>
                  <el-option :value="2" label="Operating Leases">
                  </el-option>
                  <el-option :value="3" label="Other Expenditures">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="assetCatFrom"></currency-input>
              </el-col>
              <el-col :lg="6">
                <currency-input :clearable="true" v-model="assetCatTo"></currency-input>
              </el-col>
            </el-row>
            <br>
          </el-col>
        </el-row>
      </transition>
      <br><br>
      <h3 :class="{closed: !panelDatesOpen}">Dates<span class="toggle" @click="panelDatesOpen = panelDatesOpen !== true" :class="{closed: !panelDatesOpen}"></span></h3>
      <transition name="panel">
        <el-row :gutter="20" class="pea-panel" v-if="panelDatesOpen">
          <el-col :lg="24">
            <el-row :gutter="20">
              <el-col :lg="6">
                Planned Start:
              </el-col>
              <el-col :lg="18">
                <el-date-picker
                v-model="plannedStartToFrom"
                type="daterange"
                id="startToFrom"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="min-width:400px;" />
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :lg="6">
                Planned Completion:
              </el-col>
              <el-col :lg="18">
                <el-date-picker
                v-model="plannedComToFrom"
                id="comToFrom"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="min-width:400px;" />
              </el-col>
            </el-row>
            <br>
            <br>
          </el-col>
        </el-row>
      </transition>
    </el-col>
  </el-row>
</template>

<script>
import router from '../../router'
import Filter from '@/components/utility/filter.js'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'advancedSearch',
  props: {
    filter: {
      default: new Filter()
    }
  },
  data () {
    return {
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      panelStatusOpen: false,
      panelCostOpen: false,
      panelDatesOpen: false,
      filterData: this.filter
    }
  },
  methods: {
    search () {
      var isValid = false
      isValid = this.checkValid()
      if (isValid) {
        this.filterData.buildFilterString()
        this.$parent.$emit('filterUpdate', this.filterData)
        router.push({path: '/search/results?filter=' + this.filterData.filterString, params: {filter: this.filterData}})
      }
    },
    buildFilterString () {
      var isValid = false
      isValid = this.checkValid()
      if (isValid) {
        this.filterData.buildFilterString()
        this.$emit('filterBuilt', this.filterData.filterString)
      }
    },
    updateFilter () {
      this.filterData = new Filter()
    },
    checkValid () {
      // status history
      if ((this.filterData.historyStatusId !== '' && this.filterData.historyStatusId !== null) && this.filterData.statusTo === null) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Status Change must have a Date Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.historyStatusId === '' || this.filterData.historyStatusId === null) && this.filterData.statusTo !== null) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Date Range must have a Status', 'warning', 30000, '')
        return false
      }
      // estimated cost
      if ((this.filterData.estCostFrom !== null && this.filterData.estCostFrom !== 0) && (this.filterData.estCostTo === null || this.filterData.estCostTo === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Estimated Cost To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.estCostTo !== null && this.filterData.estCostTo !== 0) && (this.filterData.estCostFrom === null || this.filterData.estCostFrom === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Estimated Cost From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.estCostTo !== null && this.filterData.estCostTo !== 0) && (this.filterData.estCostFrom !== null && this.filterData.estCostFrom !== 0)) {
        if (parseInt(this.filterData.estCostFrom) >= parseInt(this.filterData.estCostTo)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Estimated Cost Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // annual cri year 5
      if ((this.filterData.acri5From !== null && this.filterData.acri5From !== 0 && this.filterData.acri5From !== '') && (this.filterData.acri5To === null || this.filterData.acri5To === 0 || this.filterData.acri5To === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Annual CRI Year 5 To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.acri5To !== null && this.filterData.acri5To !== 0 && this.filterData.acri5To !== '') && (this.filterData.acri5From === null || this.filterData.acri5From === 0 || this.filterData.acri5From === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Annual CRI Year 5 From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.acri5From !== null && this.filterData.acri5From !== 0 && this.filterData.acri5From !== '') && (this.filterData.acri5To !== null && this.filterData.acri5To !== 0 && this.filterData.acri5To !== '')) {
        if (parseInt(this.filterData.acri5From) >= parseInt(this.filterData.acri5To)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Annual CRI Year 5 Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // annual cri year 10
      if ((this.filterData.acri10From !== null && this.filterData.acri10From !== 0 && this.filterData.acri10From !== '') && (this.filterData.acri10To === null || this.filterData.acri10To === 0 || this.filterData.acri10To === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Annual CRI Year 10 To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.acri10To !== null && this.filterData.acri10To !== 0 && this.filterData.acri10To !== '') && (this.filterData.acri10From === null || this.filterData.acri10From === 0 || this.filterData.acri10From === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Annual CRI Year 10 From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.acri10From !== null && this.filterData.acri10From !== 0 && this.filterData.acri10From !== '') && (this.filterData.acri10To !== null && this.filterData.acri10To !== 0 && this.filterData.acri10To !== '')) {
        if (parseInt(this.filterData.acri10From) >= parseInt(this.filterData.acri10To)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Annual CRI Year 10 Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // cummulative cri year 5
      if ((this.filterData.ccri5From !== null && this.filterData.ccri5From !== 0 && this.filterData.ccri5From !== '') && (this.filterData.ccri5To === null || this.filterData.ccri5To === 0 || this.filterData.ccri5To === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cummulative CRI Year 5 To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.ccri5To !== null && this.filterData.ccri5To !== 0 && this.filterData.ccri5To !== '') && (this.filterData.ccri5From === null || this.filterData.ccri5From === 0 || this.filterData.ccri5From === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cummulative CRI Year 5 From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.ccri5From !== null && this.filterData.ccri5From !== 0 && this.filterData.ccri5From !== '') && (this.filterData.ccri5To !== null && this.filterData.ccri5To !== 0 && this.filterData.ccri5To !== '')) {
        if (parseInt(this.filterData.ccri5From) >= parseInt(this.filterData.ccri5To)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Cummulative CRI Year 5 Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // cummulative cri year 10
      if ((this.filterData.ccri10From !== null && this.filterData.ccri10From !== 0 && this.filterData.ccri10From !== '') && (this.filterData.ccri10To === null || this.filterData.ccri10To === 0 || this.filterData.ccri10To === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cummulative CRI Year 10 To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.ccri10To !== null && this.filterData.ccri10To !== 0 && this.filterData.ccri10To !== '') && (this.filterData.ccri10From === null || this.filterData.ccri10From === 0 || this.filterData.ccri10From === '')) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cummulative CRI Year 10 From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.ccri10From !== null && this.filterData.ccri10From !== 0 && this.filterData.ccri10From !== '') && (this.filterData.ccri10To !== null && this.filterData.ccri10To !== 0 && this.filterData.ccri10To !== '')) {
        if (parseInt(this.filterData.ccri10From) >= parseInt(this.filterData.ccri10To)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Cummulative CRI Year 10 Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // cost in asset Classification
      if ((this.filterData.assetClassId !== '' && this.filterData.assetClassId !== null) && (this.filterData.assetClassFrom === null || this.filterData.assetClassFrom === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cost in Asset Classification From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetClassId !== '' && this.filterData.assetClassId !== null) && (this.filterData.assetClassTo === null || this.filterData.assetClassTo === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cost in Asset Classification To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetClassId === '' || this.filterData.assetClassId === null) && ((this.filterData.assetClassTo !== null && this.filterData.assetClassTo !== 0) || (this.filterData.assetClassFrom !== null && this.filterData.assetClassFrom !== 0))) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Classification Missing for Cost in Asset Classification search', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetClassId !== '' && this.filterData.assetClassId !== null) && (this.filterData.assetClassTo !== null && this.filterData.assetClassTo !== 0) && (this.filterData.assetClassFrom !== null && this.filterData.assetClassFrom !== 0)) {
        if (parseInt(this.filterData.assetClassFrom) >= parseInt(this.filterData.assetClassTo)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Cost in Asset Classification Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      // cost in asset category
      if ((this.filterData.assetCatId !== '' && this.filterData.assetCatId !== null) && (this.filterData.assetCatFrom === null || this.filterData.assetCatFrom === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cost in Asset Category From Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetCatId !== '' && this.filterData.assetCatId !== null) && (this.filterData.assetCatTo === null || this.filterData.assetCatTo === 0)) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Missing Cost in Asset Category To Range', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetCatId === '' || this.filterData.assetCatId === null) && ((this.filterData.assetCatTo !== null && this.filterData.assetCatTo !== 0) || (this.filterData.assetCatFrom !== null && this.filterData.assetCatFrom !== 0))) {
        helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Category Missing for Cost in Asset Category search', 'warning', 30000, '')
        return false
      }
      if ((this.filterData.assetCatId !== '' && this.filterData.assetCatId !== null) && (this.filterData.assetCatTo !== null && this.filterData.assetCatTo !== 0) && (this.filterData.assetCatFrom !== null && this.filterData.assetCatFrom !== 0)) {
        if (parseInt(this.filterData.assetCatFrom) >= parseInt(this.filterData.assetCatTo)) {
          helperMethods.showNotification(this.$parent, 'Invalid Search requirements', 'Cost in Asset Category Range Invalid', 'warning', 30000, '')
          return false
        }
      }
      return true
    }
  },
  computed: {
    searchId: {
      get: function () {
        return this.filterData.searchId
      },
      set: function (newValue) {
        this.filterData.searchId = newValue
      }
    },
    statusId: {
      get: function () {
        return this.filterData.statusId
      },
      set: function (newValue) {
        this.filterData.statusId = newValue
      }
    },
    owner: {
      get: function () {
        return this.filterData.owner
      },
      set: function (newValue) {
        this.filterData.owner = newValue
      }
    },
    peaName: {
      get: function () {
        return this.filterData.peaName
      },
      set: function (newValue) {
        this.filterData.peaName = newValue
      }
    },
    costCenter: {
      get: function () {
        return this.filterData.costCenter
      },
      set: function (newValue) {
        this.filterData.costCenter = newValue
      }
    },
    budget: {
      get: function () {
        return this.filterData.budget
      },
      set: function (newValue) {
        this.filterData.budget = newValue
      }
    },
    reason: {
      get: function () {
        return this.filterData.reason
      },
      set: function (newValue) {
        this.filterData.reason = newValue
      }
    },
    deptId: {
      get: function () {
        return this.filterData.deptId
      },
      set: function (newValue) {
        this.filterData.deptId = newValue
      }
    },
    divisionId: {
      get: function () {
        return this.filterData.divisionId
      },
      set: function (newValue) {
        this.filterData.divisionId = newValue
      }
    },
    emergency: {
      get: function () {
        return this.filterData.emergency
      },
      set: function (newValue) {
        this.filterData.emergency = newValue
      }
    },
    desc: {
      get: function () {
        return this.filterData.desc
      },
      set: function (newValue) {
        this.filterData.desc = newValue
      }
    },
    allText: {
      get: function () {
        return this.filterData.allText
      },
      set: function (newValue) {
        this.filterData.allText = newValue
      }
    },
    commentUserId: {
      get: function () {
        return this.filterData.commentUserId
      },
      set: function (newValue) {
        this.filterData.commentUserId = newValue
      }
    },
    approveUserId: {
      get: function () {
        return this.filterData.approveUserId
      },
      set: function (newValue) {
        this.filterData.approveUserId = newValue
      }
    },
    estCostTo: {
      get: function () {
        return this.filterData.estCostTo
      },
      set: function (newValue) {
        this.filterData.estCostTo = newValue
      }
    },
    estCostFrom: {
      get: function () {
        return this.filterData.estCostFrom
      },
      set: function (newValue) {
        this.filterData.estCostFrom = newValue
      }
    },
    acri5To: {
      get: function () {
        return this.filterData.acri5To
      },
      set: function (newValue) {
        this.filterData.acri5To = newValue
      }
    },
    acri5From: {
      get: function () {
        return this.filterData.acri5From
      },
      set: function (newValue) {
        this.filterData.acri5From = newValue
      }
    },
    acri10To: {
      get: function () {
        return this.filterData.acri10To
      },
      set: function (newValue) {
        this.filterData.acri10To = newValue
      }
    },
    acri10From: {
      get: function () {
        return this.filterData.acri10From
      },
      set: function (newValue) {
        this.filterData.acri10From = newValue
      }
    },
    ccri5To: {
      get: function () {
        return this.filterData.ccri5To
      },
      set: function (newValue) {
        this.filterData.ccri5To = newValue
      }
    },
    ccri5From: {
      get: function () {
        return this.filterData.ccri5From
      },
      set: function (newValue) {
        this.filterData.ccri5From = newValue
      }
    },
    ccri10To: {
      get: function () {
        return this.filterData.ccri10To
      },
      set: function (newValue) {
        this.filterData.ccri10To = newValue
      }
    },
    ccri10From: {
      get: function () {
        return this.filterData.ccri10From
      },
      set: function (newValue) {
        this.filterData.ccri10From = newValue
      }
    },
    assetClassFrom: {
      get: function () {
        return this.filterData.assetClassFrom
      },
      set: function (newValue) {
        this.filterData.assetClassFrom = newValue
      }
    },
    assetClassTo: {
      get: function () {
        return this.filterData.assetClassTo
      },
      set: function (newValue) {
        this.filterData.assetClassTo = newValue
      }
    },
    assetClassId: {
      get: function () {
        return this.filterData.assetClassId
      },
      set: function (newValue) {
        this.filterData.assetClassId = newValue
      }
    },
    assetCatFrom: {
      get: function () {
        return this.filterData.assetCatFrom
      },
      set: function (newValue) {
        this.filterData.assetCatFrom = newValue
      }
    },
    assetCatTo: {
      get: function () {
        return this.filterData.assetCatTo
      },
      set: function (newValue) {
        this.filterData.assetCatTo = newValue
      }
    },
    assetCatId: {
      get: function () {
        return this.filterData.assetCatId
      },
      set: function (newValue) {
        this.filterData.assetCatId = newValue
      }
    },
    plannedStartToFrom: {
      get: function () {
        return [this.filterData.plannedStartFrom, this.filterData.plannedStartTo]
      },
      set: function (newValue) {
        this.filterData.plannedStartFrom = (newValue === null) ? null : newValue[0]
        this.filterData.plannedStartTo = (newValue === null) ? null : newValue[1]
      }
    },
    plannedComToFrom: {
      get: function () {
        return [this.filterData.plannedComFrom, this.filterData.plannedComTo]
      },
      set: function (newValue) {
        this.filterData.plannedComFrom = (newValue === null) ? null : newValue[0]
        this.filterData.plannedComTo = (newValue === null) ? null : newValue[1]
      }
    },
    historyStatusId: {
      get: function () {
        return this.filterData.historyStatusId
      },
      set: function (newValue) {
        this.filterData.historyStatusId = newValue
      }
    },
    statusToFrom: {
      get: function () {
        return [this.filterData.statusFrom, this.filterData.statusTo]
      },
      set: function (newValue) {
        this.filterData.statusFrom = (newValue === null) ? null : newValue[0]
        this.filterData.statusTo = (newValue === null) ? null : newValue[1]
      }
    },
    statusTo: {
      get: function () {
        return this.filterData.statusTo
      },
      set: function (newValue) {
        this.filterData.statusTo = newValue
      }
    },
    statusFrom: {
      get: function () {
        return this.filterData.statusFrom
      },
      set: function (newValue) {
        this.filterData.statusFrom = newValue
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
